module.exports = __webpack_public_path__ + "img/image_03.826f4086.png";